module.exports = __webpack_public_path__ + "img/banner-zhiliao.ddda5790.png";